import * as React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import './style.scss';

export interface ISpbFooterNotification {
  visible?: any;
  msg?: any;
  action?: any;
  actionLabel?: any;
}

export const SpbFooterNotification: React.FC<ISpbFooterNotification> = ({ visible, msg, action, actionLabel }): JSX.Element => {
  if (!visible) return null;
  else
    return (
      <div className="d-flex footer-notification px-1">
        <Alert severity="error" className="w-100">
          <AlertTitle className="mt-1 ">
            <>
              <span> {msg}</span>
              <span className="alerte-link-style ml-2" onClick={action}>
                {' '}
                {actionLabel}
              </span>
            </>
          </AlertTitle>
        </Alert>
      </div>
    );
};
